import { IEnvironmentFromFile } from './environment.types'
import { FEATURE_FLAGS_DEV as FEATURE_FLAGS } from './feature-flags'
import { SERVICE_URLS_DEV as SERVICE_URLS } from './service-urls'

export const environmentDev: IEnvironmentFromFile = {
  ...FEATURE_FLAGS,
  ...SERVICE_URLS,

  // KEYS
  ADOBE_DTM: 'launch-EN4784749e433243eb8208fac004e2b1d9-development',
  IDS_AUTH_KEY: 'oxford-user:https://identity-dev.cinch.co.uk/:fe',
  AUTH0_AUTH_KEY:
    'oxford-user:https://auth-dev.cinch.co.uk:GnTyrV9M8uSC94BY0X2PBB9rX5mwmHuU',
  SEGMENT_KEY: '2EDvvodmSFPCpQV2U4a7GtoV2sxRDNsX',
  AUTH0_CLIENT_ID: 'GnTyrV9M8uSC94BY0X2PBB9rX5mwmHuU',
  CINCH_CHARGE_CARD_REQUEST_API_KEY: '9IHPexNUQG1RAnKt6D0Aj7gCpMbVjklaaLMir7vG',
  LOGISTICS_FULFILMENT_SERVICE_API_KEY:
    'l7kVlmgyZgaOlOVvdZV8x90Uu5mDElGG6bD2HGjb',
  STRIPE_PUBLISHABLE_KEY: 'pk_test_oWH3UdQU6FjMhxofexsj2LbB00JJTg5bhT',
  CUSTOMER_DATA_API_KEY: '579faa1b-87e1-44c0-bdbb-5ed3e4f2239c',
  GOOGLE_GEOCODING_API_KEY: 'AIzaSyDzCFu8k1pee9xWv_pCgEw6py_xF3ZjFJs',
  STORE_AVAILABILITY_KEY: 'O0gQHv0g58aMWaPKQCVAK6la4sbrA1zQ947VCUJe',
  SITES_API_KEY: 'SUBNxFWXVF6ROFYFNIFOg3hNmXy0CsMTVe9vSi6a',
  PROPOSAL_SUBMISSION_API_KEY: 'v0iOfcUcU9OmnmKwF09TkZVSvYdw5r51qDutZo80',
  IDEAL_POSTCODES_API_KEY: 'test-key',

  // EXPERIMENT IDS
  NAVBAR_VALUATION_EXPERIMENT_ID: 'value-my-car-cta-dev',
  SEARCH_DATA_DRIVEN_SORT_EXPERIMENT_ID: 'search-price-sort-dev',

  // CONSTS
  SEARCH_CHANNEL_ID: 'CINCH',
  AUTH0_DATABASE_NAME: 'Username-Password-Authentication',
  PROMO_BANNER_NAME: 'new-cars',
  ADMIN_FEE_VALUE: '9900',
  UNSUBSCRIBE_MINIMUM_DURATION: '3000',
  FINANCE_SDD_PDF: 'Cinch_SDD_v03.pdf',
  FINANCE_COMMISSION_PDF: 'commissionV7.pdf',
}
